export default "__VITE_ASSET__BbGb0aYT__"